import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchNotification(params, sort = { orderBy: "CREATED_AT_DESC" }) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/notifications", baseUrl);


  if (params.immediate) {
    endpointUrl.searchParams.append("immediate", params.immediate);
  }

  if (params.title) {
    endpointUrl.searchParams.append("title", params.title);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }
  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }
  if (sort.orderBy) {
    endpointUrl.searchParams.append("orderBy", sort.orderBy);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function usePushNotification(params = {}, sort = {}) {
  return usePaginationQuery(
    [
      "notification",
      params.title,
      params.from,
      params.to,
      params.immediate,
      params.status,
      sort.orderBy,
    ],
    (paginationState) =>
      fetchNotification({ ...params, ...paginationState }, sort)
  );
}
export async function addNotification(formData) {
  const res = await http(`/admin/notifications`, {
    data: formData,
  });
  return res;
}

export function useAddNotification() {
  const queryClient = useQueryClient();

  return useMutation(addNotification, {
    onSuccess: async (res) => {
      if (res?.status === 201 || res?.status === 200) {
        await queryClient.invalidateQueries(["notification"]);
      }
    },
  });
}

async function deleteProductGroup(id) {
  const data = await http(`/admin/notification/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteProductGroup() {
  const navigate = useNavigate();

  return useMutation(deleteProductGroup, {
    onSuccess: () => {
      setTimeout(() => {
        navigate("/notification");
      }, 1500);
    },
  });
}

// export async function fetchProductGroupDownload() {
//   const { data } = await http(`products-download`, {
//     responseType: "blob",
//   });

//   return data;
// }

// export function useProductGroupDownload() {
//   const { data, ...raResult } = useQuery(["products-download"], () =>
//     fetchProductGroupDownload()
//   );

//   return {
//     ...raResult,
//     data: data ?? {},
//   };
// }
